import "./PrimaryButton.css";
import Button from "react-bootstrap/Button";

function PrimaryButton(props) {
    return (
        <Button className="primary-button" variant="light" onClick={props.onClick} type={props.type}>{props.text}</Button>
    )
}

export default PrimaryButton;